const { createSlice } = require("@reduxjs/toolkit");

const HomeLEDSlice = createSlice({
    name: 'home_led',
    initialState: {},
    reducers: {
        "update": (state, action) => {
            let { payload } = action;
            let { status, homeId, updatedAt } = payload;
            state[homeId] = {
                status : status,
                updatedAt : updatedAt || (new Date()).toISOString(),
            }
        }
    }
});

export { HomeLEDSlice };